import { Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Router } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import SleepConsolePage from './SleepConsolePage';
import { SLEEP_CONSOLE_PATH } from './constants';

/**
 * ProtectedRouter, like every other router here: the Default layout these sit inside
 * is chrome and nothing more — it varies the header on whether someone is signed in,
 * but it renders its Outlet either way and redirects nobody.
 *
 * No permission gate beyond being signed in, though. Waking a non-production
 * environment is available to anyone who could already reach one, and the endpoint
 * behind it makes the same judgement: it accepts any token from the tenant.
 */
const SleepConsoleRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <ProtectedRouter basePath={SLEEP_CONSOLE_PATH}>
      <Routes>
        <Route path="/" element={<SleepConsolePage />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

SleepConsoleRouter.getRouterPath = () => `${SLEEP_CONSOLE_PATH}/*`;

export default SleepConsoleRouter;
